import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';

import { EstadoPyL, EstadosPyLPagingRes } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';

const { get, post, put } = erpApi();

///* tanSctack query
export const usefetchEstadosPyl = (params?: GetEstadosPylParams) => {
  return useQuery({
    queryKey: ['estadosPyl', ...Object.values(params || {})],
    queryFn: async () => {
      return getEstadosPyl(params);
    },
  });
};

export const useGetEstadoPyl = (id: string) => {
  return useQuery({
    queryKey: ['estadosPyl', id],
    queryFn: async () => {
      return getEstadoPyl(id);
    },
  });
};

export const useCreateEstadoPyl = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createEstadoPyl,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estadosPyl'] });

      navigate(returnUrl, { replace: true });
    },
  });
};

export const useUpdateEstadoPyl = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEstadoPyl,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estadosPyl'] });

      navigate(returnUrl);
    },
  });
};

///* axios
export type GetEstadosPylParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
};
export type CreateEstadosPylParams = Omit<EstadoPyL, 'id_estado_pil'>;
export type UpdateEstadosPylParams = {
  id: string;
  data: CreateEstadosPylParams;
};

export const getEstadosPyl = async (params?: GetEstadosPylParams) => {
  const { page = 1, page_size = '', nombre = '' } = params || {};

  return get<EstadosPyLPagingRes>(
    `${urlBackend}api/v1/estados-pil/?page=${page}&page_size=${page_size}&nombre=${nombre}`,
    true
  );
};

export const getEstadoPyl = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<EstadoPyL>(`${urlBackend}api/v1/estados-pil/${id}/`, true);

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};

export const createEstadoPyl = async (data: CreateEstadosPylParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<EstadoPyL>(
    `${urlBackend}api/v1/estados-pil/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};

export const updateEstadoPyl = async (params: UpdateEstadosPylParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<EstadoPyL>(
    `${urlBackend}api/v1/estados-pil/${params.id}/`,
    params.data,
    true
  );

  setAlert(true, res.message, res.status);
  return res;
};
